export const TECH_ALIASES: Record<string, string[]> = {
  solar: ['solar pv', 'photovoltaic', 'fotovoltaica', 'solar', 'pv'],
  wind: ['eólico', 'eolico', 'viento', 'eolic', 'wind'],
  bess: ['baterias', 'bateria', 'batteries', 'bess', 'ess'],
  biogas: ['biometano', 'biogas', 'gases', 'bio'],
  hydrogen: ['green hydrogen', 'hidrogeno', 'hidrógeno', 'hydrogen', 'h2v', 'h2'],
  hidropower: [
    'pumped-storage',
    'pumped hydro',
    'hidropower',
    'hydropower',
    'hidráulica',
    'hydraulic',
    'bombeo',
    'water',
    'agua',
    'pump',
    'phes',
  ],
  datacenter: [
    'centro de procesamiento de datos',
    'centros de datos',
    'centro de datos',
    'data centers',
    'datacenters',
    'cpds',
    'dc',
  ],
};

export const SEARCH_ALIASES = Object.entries(TECH_ALIASES).reduce(
  (acc, [technology, aliases]) => {
    aliases.forEach((alias) => {
      acc[alias] = { columnId: 'technologies', value: technology };
    });
    return acc;
  },
  {} as Record<string, { columnId: string; value: string }>
);

function normalize(str: string): string {
  return str
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

export function resolveTechAliases(query: string): Array<{ columnId: string; value: string }> {
  const q = normalize(query);
  if (!q) return [];

  const results: Array<{ columnId: string; value: string }> = [];

  for (const [technology, aliases] of Object.entries(TECH_ALIASES)) {
    for (const alias of aliases) {
      const a = normalize(alias);
      if (a.startsWith(q) || q.startsWith(a)) {
        results.push({ columnId: 'technologies', value: technology });
        break;
      }
    }
  }

  return results;
}
